import { shouldValidateOpgavekompleksetInput } from './_inputs.js';

function getValidatableOpgavekompleksetInputs(data, taskId, taskEntry) {
  const taskData = data.tasks.find(it => it.id === taskId);
  if (!taskData) {
    throw new Error("getValidatableInputs(): Unable to resolve related task");
  }
  const content = taskData.type === "stack" ? taskData.tasks.flatMap(it => it.content) : taskData.content;
  return content.filter(it => {
    const relatedEntry = taskEntry?.details[it.id];
    return shouldValidateOpgavekompleksetInput(it, relatedEntry);
  });
}

export { getValidatableOpgavekompleksetInputs };
//# sourceMappingURL=util.get-validatable-inputs.js.map
